import FadedText from "@components/FadedText";
import { Image } from "@kobalte/core";
import { Motion } from "@motionone/solid";
import { styled } from "solid-styled-components";

export const IMAGE_WIDTH = 150;
const HANDLE_RADIUS = 20;
export const CIRCLE_OFFSET = 3;

export const TrackImageWrapper = styled.div`
  width: ${IMAGE_WIDTH.toString()}px;
  height: ${IMAGE_WIDTH.toString()}px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProgressHandleWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const TrackImageCircle = styled(Image.Root)`
  width: calc(100% - 25px);
  height: calc(100% - 25px);
  border-radius: 50%;
  object-fit: cover;
  border: 5px solid ${({ theme }) => theme?.colors.foreground};
  border-radius: 50%;
  overflow: hidden;
  & > * {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    & > * {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ProgressHandleStatic = styled.div`
  width: ${HANDLE_RADIUS.toString()}px;
  height: ${HANDLE_RADIUS.toString()}px;
  border-radius: 50%;
  ${({ theme }) => `
		background: ${theme?.colors.foreground};
		border: 5px solid ${theme?.colors.accentPrimary};
	`};
  transform-origin: ${((IMAGE_WIDTH * 0.97 + HANDLE_RADIUS) / 2).toString()}px ${(HANDLE_RADIUS / 2).toString()}px;
  margin-right: ${(IMAGE_WIDTH * 0.97).toString()}px;
  flex-shrink: 0;
  transform: rotate(90deg);
`;

export const ProgressHandle = styled(Motion.div)`
  width: ${HANDLE_RADIUS.toString()}px;
  height: ${HANDLE_RADIUS.toString()}px;
  border-radius: 50%;
  ${({ theme }) => `
		background: ${theme?.colors.foreground};
		border: 5px solid ${theme?.colors.accentPrimary};
	`};
  transform-origin: ${((IMAGE_WIDTH * 0.97 + HANDLE_RADIUS) / 2).toString()}px ${(HANDLE_RADIUS / 2).toString()}px;
  margin-right: ${(IMAGE_WIDTH * 0.97).toString()}px;
  flex-shrink: 0;
  transform: rotate(90deg);
`;

export const ProgressWrapper = styled.svg<{ loading?: boolean }>`
  transform: rotate(-90deg);
  stroke-dasharray: ${(2 * Math.PI * (IMAGE_WIDTH / 2 - CIRCLE_OFFSET)).toString()};
  stroke-dashoffset: ${(2 * Math.PI * (IMAGE_WIDTH / 2 - CIRCLE_OFFSET)).toString()};
  ${({ loading }) => (loading ? "" : "transition: stroke-dashoffset 0.41s;")}
`;
export const CurrentTime = styled(FadedText)`
  position: absolute;
  left: -50px;
  top: ${(IMAGE_WIDTH / 2).toString()}px;
`;
export const TrackLength = styled(CurrentTime)`
  right: -50px;
  left: unset;
`;
